import { Disclaimer } from '@/api/Checkout/checkout.interfaces';
import {
    getBaggageInsuranceGeneralTermsLink,
    getBaggageInsurancePurchaseTermsLink,
    getOurPoliciesLink,
    getTravelConditionsLink,
    getTravelInsuranceGeneralTermsLink,
    getTravelInsurancePurchaseTermsLink,
} from '@shared/config/market/market.helpers';
import { AddonProduct, SerializationType } from '@/api/Cart/cart.interfaces';
import { Links } from '@/api/MyBooking/myBooking.interfaces';

export const getUpdatedDisclaimers = (disclaimers: Disclaimer[]): Disclaimer[] => {
    return disclaimers.map((d) => {
        return {
            ...d,
            LinkUrl: getDisclaimerLinkUrl(d),
        } as Disclaimer;
    });
};

const getDisclaimerLinkUrl = (disclaimer: Disclaimer): string | null => {
    switch (disclaimer.Id) {
        case 'terms':
            return getTravelConditionsLink();
        case 'privacyPolicy':
            return getOurPoliciesLink() + '#why_we_collect_data';
        default:
            return disclaimer.LinkUrl;
    }
};

export const getUpdatedAddons = (addon: AddonProduct[]): AddonProduct[] => {
    return addon.map((a) => {
        let extraLink = '';

        if (a.$type === SerializationType.LuggageInsurance) {
            extraLink = getBaggageInsurancePurchaseTermsLink();
        }

        if (a.$type === SerializationType.TravelInsurance) {
            extraLink = getTravelInsurancePurchaseTermsLink();
        }

        return {
            ...a,
            LinkUrl: getAddonLinkUrl(a),
            ...(extraLink && { LinkUrlSecondary: extraLink }),
        } as AddonProduct;
    });
};

const getAddonLinkUrl = (addon: AddonProduct): string | null => {
    switch (addon.$type) {
        case SerializationType.CancellationInsurance:
            return getTravelConditionsLink() + '#cancellation_insurance';
        case SerializationType.ServicePackage:
            return getTravelConditionsLink() + '#servicepackage';
        case SerializationType.LuggageInsurance:
            return getBaggageInsuranceGeneralTermsLink();
        case SerializationType.TravelInsurance:
            return getTravelInsuranceGeneralTermsLink();
        default:
            return addon.LinkUrl;
    }
};

export const getUpdatedMyBookingLinks = (links: Links): Links => {
    const updatedLinks = { ...links };
    updatedLinks.termsAndCondition = getTravelConditionsLink();
    return updatedLinks;
};

export const disclaimersToRedirect = ['terms', 'privacyPolicy'];
export const addonsToRedirect = [
    'CancellationInsurance',
    'ServicePackage',
    'LuggageInsurance',
    'TravelInsurance',
];
